import React, { useState, useEffect, useRef, useCallback } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { FaPaperPlane } from 'react-icons/fa';
import api from '../services/api';

const HOUR_HEIGHT = 64;
const EVENT_COLORS = [
  { bg: '#dbeafe', border: '#3b82f6', text: '#1e40af' },
  { bg: '#ede9fe', border: '#8b5cf6', text: '#5b21b6' },
  { bg: '#d1fae5', border: '#10b981', text: '#065f46' },
  { bg: '#fef3c7', border: '#f59e0b', text: '#78350f' },
];

// const taskOptionsStatic = [
//   // Scripting Tasks
//   { value: "scripting_questionnaire_review", label: "Scripting - Questionnaire Review" },
//   { value: "scripting_standard_templates", label: "Scripting - Standard Templates (includes template preparation, simple logics, variable naming, and test/live link creation)" },
//   { value: "scripting_scripting_logics", label: "Scripting - Scripting Logics (complex logics such as looping, max-diff, product rotation using external files)" },
//   { value: "scripting_updating_feedbacks", label: "Scripting - Updating Feedbacks (from researchers, co-scripters, etc.)" },
//   { value: "scripting_rework_1", label: "Scripting - Rework 1 (questionnaire revision, revised logics, issues from research)" },
//   { value: "scripting_rework_2", label: "Scripting - Rework 2 (issues from scripting)" },
//   { value: "scripting_follow_up", label: "Scripting - Follow-Up (technical challenges, discussions with S2C & S2G, platform issues)" },
//   { value: "scripting_others", label: "Scripting - Others" },

//   // Quality Checks
//   { value: "quality_checks_qc_survey", label: "Quality Checks - Survey QC" },
//   { value: "quality_checks_qc_co_scripter", label: "Quality Checks - Co-Scripter Survey QC" },
//   { value: "quality_checks_others", label: "Quality Checks - Others" },

//   // Raw Data Tasks
//   { value: "raw_data_extract_share", label: "Raw Data - Extract & Share with Researchers" },
//   { value: "raw_data_deletion", label: "Raw Data - Data Deletion (per QC report)" },
//   { value: "raw_data_checking", label: "Raw Data - Data Checking" },
//   { value: "raw_data_preparation", label: "Raw Data - Data Preparation (e.g., DPCX)" },
//   { value: "raw_data_merging", label: "Raw Data - Merging (syntax preparation, merging across platforms, tracker merging)" },
//   { value: "raw_data_others", label: "Raw Data - Others" },

//   // OE Data Tasks
//   { value: "oe_data_preparation", label: "OE Data - Preparation for Coding/Verbatim for Researchers" },
//   { value: "oe_data_conversion", label: "OE Data - Conversion to SPSS Format" },
//   { value: "oe_data_costing", label: "OE Data - Costing Calculation" },
//   { value: "oe_data_others", label: "OE Data - Others" },

//   // Database Tasks
//   { value: "database_cleaning", label: "Database - Cleaning (formatting, validating email links, etc.)" },
//   { value: "database_unique_links", label: "Database - Creating Unique Links" },
//   { value: "database_others", label: "Database - Others" },

//   // Quota Tasks
//   { value: "quota_setup", label: "Quota - Setup and Tracker Updates" },
//   { value: "quota_monitoring", label: "Quota - Monitoring & Quota Sheet Preparation" },
//   { value: "quota_rework_1", label: "Quota - Rework 1 (due to quota issues/multiple research versions)" },
//   { value: "quota_rework_2", label: "Quota - Rework 2 (due to scripting quota issues)" },
//   { value: "quota_others", label: "Quota - Others" },

//   // Dashboard Tasks
//   { value: "dashboard_hsbc", label: "Dashboard - HSBC Dashboards" },

//   // General Tasks
//   { value: "general_meeting_fun", label: "General - Meetings, Fun Activities, Celebrations, etc." },

//   // Upskilling
//   { value: "up_skilling_powerbi", label: "Upskilling - Power BI, Python, SPSS, Dimensions, etc." },
//   { value: "up_skilling_communication", label: "Upskilling - Communication Skills" },

//   // Email & Invitation Tasks
//   { value: "email_invitation_preparation", label: "Email Invitation Preparation" },

//   // Discussion Tasks
//   { value: "discussion_xebo", label: "Discussion with XEBO (regarding issues)" },

//   // Translations
//   { value: "scripting_translations", label: "Scripting - Translations" },

//   // Survey Launching
//   { value: "survey_launching", label: "Survey Launching Process" },

//   // Quota Issues Discussion
//   { value: "quota_issues", label: "Quota Issues (including discussions)" },

//   // Template & Logo Tasks
//   { value: "template_logos", label: "Template - Logos" },

//   // Shared Data
//   { value: "shared_sample_data", label: "Shared Sample Data" },

//   // Triggered Notifications
//   { value: "triggered_email_sms_reminders", label: "Triggered Email / SMS Reminders" },
//   { value: "sms_trigger", label: "SMS Trigger" },
//   { value: "email_trigger", label: "Email Trigger" },

//   // Logic Issues
//   { value: "logic_issues", label: "Logic Issues" },

//   // DP (Data Processing) Tasks
//   { value: "dp_analysis_plan_review", label: "DP - Analysis Plan Review" },
//   { value: "dp_questionnaire_review", label: "DP - Questionnaire Review" },
//   { value: "dp_template_editing", label: "DP - Template Editing" },
//   { value: "dp_template_tables_template_creation", label: "DP - Tables Template Creation" },
//   { value: "dp_template_banner_creation", label: "DP - Banner Creation" },
//   { value: "dp_template_weighting", label: "DP - Weighting" },
//   { value: "dp_template_oe_table_setup", label: "DP - OE Table Setup" },
//   { value: "dp_interim_data_tables_generates", label: "DP - Interim Data Tables Generation" },
//   { value: "dp_final_data_tables_generates", label: "DP - Final Data Tables Generation" },
//   { value: "dp_additional_request", label: "DP - Additional Request" },
//   { value: "dp_interim_tables_qc", label: "DP - Interim Tables QC" },
//   { value: "dp_final_tables_qc", label: "DP - Final Tables QC" },
//   { value: "dp_oe_data_qc", label: "DP - OE Data QC" },

//   // Status and Norms
//   { value: "status_update", label: "Status Update" },
//   { value: "norms", label: "Norms" },

//   // Stacked SPSS Tasks
//   { value: "stacked_spss_generates", label: "Stacked SPSS Generation" },
//   { value: "stacked_spss_qc", label: "Stacked SPSS QC" },

//   // SPSS Tasks
//   { value: "spss_data_preparation_regression", label: "SPSS - Data Preparation for Regression Analysis" },
//   { value: "spss_data_updates", label: "SPSS - Data Updates" },
//   { value: "spss_data_merging", label: "SPSS - Data Merging" },
//   { value: "spss_recode_cleaning_split", label: "SPSS - Recode, Cleaning, Split" },

//   // Not Applicable
//   { value: "na", label: "Not Applicable" }
// ];


const taskOptionsStatic = [
  // ---------------------------------------------------------------------------
  // I. PROJECT MANAGEMENT & COMMUNICATION
  // ---------------------------------------------------------------------------
  { value: "pm_comm_kick_off_briefing", label: "PM & Comm - Project Kick-off / Briefing Meetings (Internal/Client)" },
  { value: "pm_comm_internal_planning", label: "PM & Comm - Internal DP Team Planning & Strategy Meetings" },
  { value: "pm_comm_researcher_consultation", label: "PM & Comm - Ongoing Consultation with Researchers" },
  { value: "pm_comm_client_communication", label: "PM & Comm - Client Communication (Updates, Queries - if DP involved)" },
  { value: "pm_comm_vendor_liaison", label: "PM & Comm - Liaison with External Vendors (e.g., Panel, Translation, Coding)" },
  { value: "pm_comm_status_updates", label: "PM & Comm - Project Status Updates & Reporting" },
  { value: "pm_comm_problem_solving_escalation", label: "PM & Comm - Technical Problem Solving & Escalation Discussions" }, // Catches "Follow-Up", "Logic Issues Discussion"
  { value: "pm_comm_documentation", label: "PM & Comm - Project Documentation (Specs, Logs, Issue Tracking)" },


  { value: "datacorrect_error_identification_logging", label: "Data Correction - Error Identification & Logging (from QC, Researcher feedback)" },
  { value: "datacorrect_respondent_data_review", label: "Data Correction - Individual Respondent Data Review & Manual Edits" },
  { value: "datacorrect_logical_inconsistency_resolution", label: "Data Correction - Resolving Logical Inconsistencies & Contradictions" },
  { value: "datacorrect_data_imputation", label: "Data Correction - Data Imputation (if applicable & approved)" },
  { value: "datacorrect_verbatim_cleaning_standardization_oe", label: "Data Correction - Verbatim Cleaning/Standardization (OE Text)" },
  { value: "datacorrect_backcoding_oe", label: "Data Correction - Backcoding Open-Ends / 'Other Specify'" },
  { value: "datacorrect_syntax_based_correction", label: "Data Correction - Syntax-Based Correction Scripts (SPSS, R, Python)" },
  { value: "datacorrect_respondent_deletion_errors", label: "Data Correction - Respondent Deletion (based on identified data errors/QC)" }, // Moved from Raw Data
  { value: "datacorrect_correction_qc", label: "Data Correction - Quality Check of Applied Corrections" },
  { value: "datacorrect_documentation_changes", label: "Data Correction - Documenting All Data Changes & Corrections" },
  { value: "datacorrect_others", label: "Data Correction - Others" },
  // ---------------------------------------------------------------------------
  // II. QUESTIONNAIRE & ANALYSIS PLAN REVIEW (PRE-SCRIPTING)
  // ---------------------------------------------------------------------------
  { value: "qre_ap_questionnaire_review_dp", label: "QRE & AP - Questionnaire Review (DP Feasibility & Logic)" }, // Combines Scripting & DP Qre review
  { value: "qre_ap_analysis_plan_review", label: "QRE & AP - Analysis Plan / Tab Spec Review" },
  { value: "qre_ap_data_spec_clarification", label: "QRE & AP - Data Specification Clarification" },

  // ---------------------------------------------------------------------------
  // III. SURVEY SCRIPTING & SETUP
  // ---------------------------------------------------------------------------
  { value: "scripting_template_preparation", label: "Scripting - Standard Template Customization (Branding, Logos)" }, // Includes "Template - Logos"
  { value: "scripting_standard_programming", label: "Scripting - Standard Programming (Simple Logic, Variable Naming)" },
  { value: "scripting_complex_programming", label: "Scripting - Complex Programming (Looping, MaxDiff, Conjoint, Piping, Masking, Custom Validations)" },
  { value: "scripting_external_file_integration", label: "Scripting - External File Integration (Product Lists, Rotations)" },
  { value: "scripting_translation_implementation", label: "Scripting - Translation Implementation & Testing" },
  { value: "scripting_quota_module_setup", label: "Scripting - Quota Module Logic Setup in Survey" },
  { value: "scripting_feedback_updates", label: "Scripting - Implementing Feedback (Researcher, QC, Co-Scripter)" },
  { value: "scripting_rework_revisions", label: "Scripting - Rework / Revisions (Qre changes, Logic updates)" }, // Combines Rework 1 & 2
  { value: "scripting_test_live_link_generation", label: "Scripting - Test & Live Survey Link Generation" },
  { value: "scripting_platform_troubleshooting", label: "Scripting - Survey Platform Specific Troubleshooting/Workarounds" },
  { value: "scripting_others", label: "Scripting - Others" },

  // ---------------------------------------------------------------------------
  // IV. SCRIPTING & DATA QUALITY CHECKS (PRE-LAUNCH & IN-FIELD)
  // ---------------------------------------------------------------------------
  { value: "qc_script_self_test", label: "QC - Script Self-Testing / Dry Runs" },
  { value: "qc_script_peer_review", label: "QC - Co-Scripter / Peer Script Review" }, // Formerly "Co-Scripter Survey QC"
  { value: "qc_script_researcher_pilot_feedback", label: "QC - Incorporating Researcher Pilot Feedback" },
  { value: "qc_live_data_initial_checks", label: "QC - Initial Live Data Checks (Soft Launch)" },
  { value: "qc_data_quality_monitoring_infield", label: "QC - In-field Data Quality Monitoring (Speeders, Flatliners)" },
  { value: "qc_others", label: "QC - Others" },

  // ---------------------------------------------------------------------------
  // V. SAMPLE MANAGEMENT & FIELDWORK SUPPORT
  // ---------------------------------------------------------------------------
  { value: "sample_db_cleaning_formatting", label: "Sample Mgt - Database Cleaning & Formatting (Contacts, Emails)" },
  { value: "sample_db_unique_link_generation", label: "Sample Mgt - Unique Survey Link Generation for Sample" },
  { value: "sample_invitation_email_sms_prep", label: "Sample Mgt - Email/SMS Invitation & Reminder Preparation/Setup" }, // Combines "Email Invitation Preparation", "Triggered Email / SMS Reminders"
  { value: "sample_shared_data_prep", label: "Sample Mgt - Shared Sample Data Preparation/Handling" },
  { value: "quota_setup_field", label: "Quota Mgt - Field Quota Setup & Tracker Updates (Platform/Manual)" },
  { value: "quota_monitoring_management", label: "Quota Mgt - Quota Monitoring, Reporting & Adjustment" }, // Includes "Quota Sheet Preparation"
  { value: "quota_issue_resolution", label: "Quota Mgt - Quota Issue Investigation & Resolution" }, // Combines "Rework 1 & 2" and "Quota Issues"
  { value: "survey_launch_coordination", label: "Field Support - Survey Launch Coordination & Go-Live Checks" }, // "Survey Launching Process"
  { value: "field_technical_support", label: "Field Support - Addressing Technical Issues During Fieldwork" },
  { value: "sample_others", label: "Sample Mgt - Others" },
  { value: "quota_others", label: "Quota Mgt - Others" },

  // ---------------------------------------------------------------------------
  // VI. RAW DATA MANAGEMENT & PREPARATION
  // ---------------------------------------------------------------------------
  { value: "rawdata_extraction_delivery", label: "Raw Data - Extraction & Initial Delivery to Researchers" },
  { value: "rawdata_cleaning_validation", label: "Raw Data - Cleaning & Validation (Logic checks, Outliers, Duplicates)" }, // Enhanced "Data Checking"
  { value: "rawdata_deletion_qc_report", label: "Raw Data - Respondent Deletion (per QC/Client instructions)" },
  { value: "rawdata_oe_preparation_coding", label: "Raw Data - OE Preparation for Coding (Export/Formatting)" }, // "OE Data - Preparation for Coding/Verbatim"
  { value: "rawdata_coded_oe_integration", label: "Raw Data - Integrating Coded OE Data back into Main Dataset" },
  { value: "rawdata_merging_datasets", label: "Raw Data - Merging Datasets (Trackers, Multiple sources/platforms)" },
  { value: "rawdata_transformation_recoding", label: "Raw Data - Data Transformation (Recoding, Variable Derivation)" },
  { value: "rawdata_formatting_spss_other", label: "Raw Data - Formatting for SPSS/Other Analysis Software" }, // Includes "OE Data - Conversion to SPSS Format"
  { value: "rawdata_weighting_preparation", label: "Raw Data - Data Preparation for Weighting" },
  { value: "rawdata_costing_oe_translation", label: "Raw Data - Costing Calculation (OE Coding, Translation)" }, // "OE Data - Costing Calculation"
  { value: "rawdata_others", label: "Raw Data - Others" },
  { value: "oe_data_others", label: "OE Data - Others (specific to OE if not covered)" }, // Kept if OE has distinct tasks not covered.
  { value: "database_others", label: "Database Tasks - Others (if not sample related)" }, // Kept for non-sample DB tasks.
  { value: "excel_to_spss", label: "Excel to SPSS data converstion / Syntax writing" }, // Kept for non-sample DB tasks.

  // ---------------------------------------------------------------------------
  // VII. DATA PROCESSING & TABULATION
  // ---------------------------------------------------------------------------
  { value: "dp_tab_spec_finalization", label: "DP - Tabulation Spec Finalization/Creation" }, // "Analysis Plan Review" is earlier, this is about the spec itself
  { value: "dp_table_template_setup", label: "DP - Table Template Setup (Shells, Banners, Nets)" }, // Combines "Template Editing", "Tables Template Creation", "Banner Creation"
  { value: "dp_weighting_application_qc", label: "DP - Weighting Scheme Application & QC" }, // "Weighting"
  { value: "dp_oe_table_setup", label: "DP - OE Data Preparation / Table Setup in Tables" },
  { value: "dp_interim_tables_generation", label: "DP - Interim Table Generation" },
  { value: "dp_final_tables_generation", label: "DP - Final Table Generation" },
  { value: "dp_statistical_testing_setup", label: "DP - Statistical Testing Setup in Tables (Sig-testing)" },
  { value: "dp_chart_table_preparation", label: "DP - Chart Table Preparation" },
  { value: "dp_data_for_advanced_analytics", label: "DP - Data Preparation for Advanced Analytics (Regression, Segmentation)" }, // "SPSS - Data Preparation for Regression Analysis"
  { value: "dp_spss_stacked_file_generation", label: "DP - SPSS/Stacked Data File Generation" }, // "Stacked SPSS Generation"
  { value: "dp_norms_database_update", label: "DP - Norms Database Calculation & Update" }, // "Norms"
  { value: "dp_additional_requests_reruns", label: "DP - Additional Table Requests / Re-runs" },
  { value: "dp_others", label: "DP - Others" },

  // ---------------------------------------------------------------------------
  // VIII. DP QUALITY CONTROL (POST-FIELD)
  // ---------------------------------------------------------------------------
  { value: "qc_dp_raw_data_final_check", label: "QC (DP) - Final Raw Data Validation (Pre-tabulation)" },
  { value: "qc_dp_weighting_accuracy", label: "QC (DP) - Weighting Scheme Accuracy Check" },
  { value: "qc_dp_interim_tables", label: "QC (DP) - Interim Table QC (Counts, Bases, Logic)" },
  { value: "qc_dp_final_tables", label: "QC (DP) - Final Table QC (Counts, Bases, Logic, Formatting)" },
  { value: "qc_dp_spss_stacked_file", label: "QC (DP) - SPSS/Stacked Data File QC" }, // "Stacked SPSS QC"
  { value: "qc_dp_oe_data_final", label: "QC (DP) - Final Coded OE Data QC" }, // "DP - OE Data QC"
  { value: "qc_dp_chart_data_accuracy", label: "QC (DP) - Chart Data Accuracy Check" },
  { value: "qc_dp_dashboard_data_accuracy", label: "QC (DP) - Dashboard Data Accuracy Check" },

  // ---------------------------------------------------------------------------
  // IX. DELIVERABLES & REPORTING SUPPORT
  // ---------------------------------------------------------------------------
  { value: "deliverable_dashboard_creation_update", label: "Deliverable - Dashboard Creation/Update (e.g., PowerBI, Tableau, Specific Client Dashboards like HSBC)" }, // "Dashboard - HSBC"
  { value: "deliverable_chart_material_prep", label: "Deliverable - Chart Material Preparation for Reports" },
  { value: "deliverable_final_data_export_formats", label: "Deliverable - Final Data Export in Various Formats (SPSS, Excel, CSV)" },
  { value: "deliverable_report_automation_support", label: "Deliverable - Report Automation Support" },
  { value: "deliverable_archiving", label: "Deliverable - Project Data & Document Archiving" },

  // ---------------------------------------------------------------------------
  // X. GENERAL & ADMINISTRATIVE
  // ---------------------------------------------------------------------------
  { value: "general_team_meetings_activities", label: "General - Team Meetings, Fun Activities, Celebrations" },
  { value: "general_admin_timesheets", label: "General - Administrative Tasks (Timesheets, etc.)" },
  { value: "general_process_improvement_initiatives", label: "General - Process Improvement Initiatives & Discussions" },
  { value: "general_tool_evaluation_testing", label: "General - New Tool/Software Evaluation & Testing" },
  { value: "general_knowledge_sharing_sessions", label: "General - Internal Knowledge Sharing Sessions" },

  // ---------------------------------------------------------------------------
  // XI. UPSKILLING & TRAINING
  // ---------------------------------------------------------------------------
  { value: "training_technical_skills", label: "Upskilling - Technical Skills (Power BI, Python, SPSS, Dimensions, New Platforms)" },
  { value: "training_soft_skills", label: "Upskilling - Soft Skills (Communication, Presentation, Project Management)" },
  { value: "training_new_methodologies", label: "Upskilling - Learning New Research Methodologies & DP Implications" },
  { value: "training_onboarding_new_staff", label: "Upskilling - Onboarding/Training New Team Members" },

  // ---------------------------------------------------------------------------
  // XII. MISCELLANEOUS / OTHER
  // ---------------------------------------------------------------------------
  { value: "other_unspecified_task", label: "Other - Unspecified Task (Please specify)" },
  { value: "others", label: "Others General" },
  { value: "na_not_applicable", label: "Not Applicable" }
];

// For reference, these were some of your less categorized items that got integrated:
// { value: "discussion_xebo", label: "Discussion with XEBO (regarding issues)" }, // -> pm_comm_vendor_liaison or pm_comm_problem_solving_escalation
// { value: "logic_issues", label: "Logic Issues" }, // -> scripting_rework_revisions or pm_comm_problem_solving_escalation
// { value: "spss_data_updates", label: "SPSS - Data Updates" }, // -> rawdata_transformation_recoding or part of dp_additional_requests_reruns
// { value: "spss_data_merging", label: "SPSS - Data Merging" }, // -> rawdata_merging_datasets
// { value: "spss_recode_cleaning_split", label: "SPSS - Recode, Cleaning, Split" }, // -> rawdata_transformation_recoding and rawdata_cleaning_validation

const VIEW_TABS = ['Day', 'Week', 'Month', 'Agenda'];

function formatHour(h) {
  if (h === 0) return '12 AM';
  if (h === 12) return '12 PM';
  if (h < 12) return `${h} AM`;
  return `${h - 12} PM`;
}

function Timesheet() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refreshEvents, setRefreshEvents] = useState(false);
  const [events, setEvents] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedTask, setSelectedTask] = useState('');
  const [sendingEmail, setSendingEmail] = useState(false);
  const [deletedEvent, setDeletedEvent] = useState(null);

  // New calendar state
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calView, setCalView] = useState('Day');
  const [showFullDay, setShowFullDay] = useState(true);
  const [nowTime, setNowTime] = useState(new Date());

  // Drag-to-select state
  const [dragState, setDragState] = useState(null); // { startY, currentY } in px
  const gridRef = useRef(null);

  // Update the "now" line every minute
  useEffect(() => {
    const interval = setInterval(() => setNowTime(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  // Fetch project options on component mount
  useEffect(() => {
    const token = localStorage.getItem("Token");

    api
      .get('api/segments/unique_segments_with_job/', {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.data.unique_segment_names?.length > 0) {
          const validSegments = response.data.unique_segment_names.filter(
            (name) => name !== null && name.trim() !== ""
          );
          setProjectOptions(validSegments);
        } else {
          console.error("No unique segment names found");
          setProjectOptions([]);
        }
      })
      .catch((error) => console.error('Error fetching unique segment names:', error));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("Token");

    api
      .get("timesheet/api/events/", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.data.length > 0) {
          let cumulativeSum = 0;
          const formattedEvents = response.data.flatMap((event) =>
            event.time_slots.map((slot) => {
              const duration = moment.utc(slot.end_time).diff(moment.utc(slot.start_time), "minutes");
              cumulativeSum += duration;
              return {
                id: event.id,
                title: `${event.project || ""}${event.task ? ", " + event.task : ""}`,
                start: moment.utc(slot.start_time).local().toDate(),
                end: moment.utc(slot.end_time).local().toDate(),
                cumulativeSum,
              };
            })
          );
          setEvents(formattedEvents);
        } else {
          console.warn("No events found");
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, [refreshEvents]);

  const handleSendTimesheetEmail = () => {
    const token = localStorage.getItem("Token");
    if (!token) {
      alert("You are not logged in.");
      return;
    }

    setSendingEmail(true);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    api
      .post(
        "timesheet/api/send-summary-email/",
        { timezone },
        { headers: { Authorization: `Token ${token}` } }
      )
      .then((response) => {
        const { sent_to, cc } = response.data;
        const allRecipients = [...sent_to, ...cc].join(', ');
        alert(`Timesheet summary sent successfully to: ${allRecipients}`);
      })
      .catch((error) => {
        const msg = error.response?.data?.error || "Failed to send email. Please try again.";
        alert(msg);
      })
      .finally(() => {
        setSendingEmail(false);
      });
  };

  const handleSelectSlot = ({ start, end }) => {
    const startLocal = moment(start).local();
    const endLocal = moment(end).local();

    const dates = [];
    const times = [];

    let currentDate = startLocal.clone();
    while (currentDate <= endLocal) {
      dates.push(currentDate.clone());
      currentDate.add(1, 'day');
    }
    setSelectedDates(dates);

    let currentTime = startLocal.clone();
    while (currentTime < endLocal) {
      times.push({
        start: currentTime.clone(),
        end: currentTime.clone().add(30, 'minutes'),
      });
      currentTime.add(30, 'minutes');
    }
    setSelectedTimeSlots(times);
    setShowAddModal(true);
  };

  const handleAddModalClose = () => {
    setShowAddModal(false);
    setSelectedDates([]);
    setSelectedTimeSlots([]);
    setSelectedProject('');
    setSelectedTask('');
    setRefreshEvents((prev) => !prev);
  };

  const handleAddModalSubmit = () => {
    if (!selectedProject || !selectedProject.value) {
      alert("Please select a project!");
      return;
    }
    if (!selectedTask || !selectedTask.value) {
      alert("Please select a task!");
      return;
    }
    if (selectedDates.length === 0 || selectedTimeSlots.length === 0) {
      alert("Please select at least one date and time slot!");
      return;
    }

    const token = localStorage.getItem("Token");
    if (!token) {
      console.error("Token not found");
      return;
    }

    const projectString = selectedProject.value;
    const taskString = selectedTask.label;

    const timeSlots = selectedTimeSlots.map((slot) => ({
      start_time: slot.start.toISOString(),
      end_time: slot.end.toISOString(),
    }));

    api
      .post(
        "timesheet/api/events/",
        {
          project: projectString,
          task: taskString,
          start_date: moment(selectedDates[0]).format("YYYY-MM-DD"),
          end_date: moment(selectedDates[selectedDates.length - 1]).format("YYYY-MM-DD"),
          time_slots: timeSlots,
        },
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data && response.data.id) {
          const newEvents = timeSlots.map((slot) => ({
            id: response.data.id,
            title: `${projectString || ""}${taskString ? ", " + taskString : ""}`,
            start: moment.utc(slot.start_time).local().toDate(),
            end: moment.utc(slot.end_time).local().toDate(),
          }));

          const groupedEvents = newEvents.reduce((acc, event) => {
            if (!acc[event.title]) {
              acc[event.title] = [];
            }
            acc[event.title].push(event);
            return acc;
          }, {});

          setEvents((prevEvents) => {
            const groupedPrevEvents = prevEvents.reduce((acc, event) => {
              if (!acc[event.title]) {
                acc[event.title] = [];
              }
              acc[event.title].push(event);
              return acc;
            }, {});
            return [
              ...Object.values(groupedPrevEvents).flat(),
              ...Object.values(groupedEvents).flat(),
            ];
          });
        } else {
          console.error("Failed to create event: Invalid response", response);
        }
        handleAddModalClose();
      })
      .catch((error) => {
        console.error("Error creating event:", error.response?.data || error.message || error);
        alert(error.response?.data?.project?.[0] || error.response?.data?.task?.[0] || "There was an error creating the event. Please try again.");
      });
  };

  const handleDeleteEvent = () => {
    const eventToDelete = selectedEvent;

    api
      .delete(`timesheet/api/events/${eventToDelete.id}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("Token")}`,
        },
      })
      .then(() => {
        setDeletedEvent(eventToDelete);
        setEvents((prevEvents) => prevEvents.filter((event) => event.id !== eventToDelete.id));
        setRefreshEvents((prev) => !prev);
      })
      .catch((error) => {
        console.error("Error deleting event:", error);
        alert("Failed to delete event. Please try again.");
      });
  };

  // Undo deletion
  const handleUndoDelete = () => {
    if (deletedEvent) {
      api
        .post(
          "timesheet/api/events/",
          {
            project: deletedEvent.project,
            task: deletedEvent.task,
            start_date: moment(deletedEvent.start).format("YYYY-MM-DD"),
            end_date: moment(deletedEvent.end).format("YYYY-MM-DD"),
            time_slots: [
              {
                start_time: moment(deletedEvent.start).toISOString(),
                end_time: moment(deletedEvent.end).toISOString(),
              },
            ],
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((response) => {
          setEvents((prevEvents) => [...prevEvents, response.data]);
          setDeletedEvent(null);
          alert("Event restored successfully.");
        })
        .catch((error) => {
          console.error("Error restoring event:", error);
          alert("Failed to restore event. Please try again.");
        });
    }
  };

  const getReactSelectProjectOptions = (options) => {
    const mappedOptions = options.map(option => ({ value: option, label: option }));
    if (!options.includes("Others")) {
      mappedOptions.push({ value: "Others", label: "Others" });
    }
    return mappedOptions;
  };

  const handleProjectChange = (selectedOption) => {
    setSelectedProject(selectedOption);
  };

  const handleChange = (selectedOption) => {
    setSelectedTask(selectedOption);
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    const [project, task] = event.title.split(', ');
    setSelectedProject(project || '');
    setSelectedTask(task || '');
    setShowEditModal(true);
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setSelectedEvent(null);
    setSelectedProject('');
    setSelectedTask('');
  };

  // ---------------------------------------------------------------------------
  // Calendar rendering helpers
  // ---------------------------------------------------------------------------
  const rangeStart = showFullDay ? 0 : 6;
  const rangeEnd = showFullDay ? 24 : 21;
  const hours = Array.from({ length: rangeEnd - rangeStart }, (_, i) => rangeStart + i);

  // Only show events on the currently viewed day
  const dayEvents = events.filter(event =>
    moment(event.start).isSame(moment(currentDate), 'day')
  );

  // Day load strip: calculate booked percentage within visible range
  const totalVisibleMinutes = (rangeEnd - rangeStart) * 60;
  let bookedMinutes = 0;
  dayEvents.forEach(event => {
    const evStartH = moment(event.start).hours() + moment(event.start).minutes() / 60;
    const evEndH = moment(event.end).hours() + moment(event.end).minutes() / 60;
    const clampedStart = Math.max(evStartH, rangeStart);
    const clampedEnd = Math.min(evEndH, rangeEnd);
    if (clampedEnd > clampedStart) bookedMinutes += (clampedEnd - clampedStart) * 60;
  });
  const bookedPercent = Math.min(100, Math.round((bookedMinutes / totalVisibleMinutes) * 100));

  // "Now" line
  const isToday = moment(currentDate).isSame(moment(), 'day');
  const nowHour = nowTime.getHours() + nowTime.getMinutes() / 60;
  const nowTop = (nowHour - rangeStart) * HOUR_HEIGHT;
  const showNowLine = isToday && nowHour >= rangeStart && nowHour < rangeEnd;

  // Drag-to-select handlers
  const snapToHalf = (hour) => Math.round(hour * 2) / 2; // snap to nearest 30 min

  const handleGridMouseDown = useCallback((e) => {
    if (e.target !== e.currentTarget) return; // only on empty grid, not events
    if (e.button !== 0) return; // left click only
    const rect = gridRef.current.getBoundingClientRect();
    const y = Math.max(0, e.clientY - rect.top);
    setDragState({ startY: y, currentY: y });
    e.preventDefault();
  }, []);

  const handleGridMouseMove = useCallback((e) => {
    if (!dragState) return;
    const rect = gridRef.current.getBoundingClientRect();
    const y = Math.max(0, Math.min(e.clientY - rect.top, gridRef.current.scrollHeight));
    setDragState(prev => prev ? { ...prev, currentY: y } : null);
  }, [dragState]);

  const handleGridMouseUp = useCallback((e) => {
    if (!dragState) return;
    const { startY, currentY } = dragState;
    setDragState(null);

    const minY = Math.min(startY, currentY);
    const maxY = Math.max(startY, currentY);
    const isDrag = maxY - minY > 8; // > 8px = intentional drag

    if (isDrag) {
      const startHour = snapToHalf(rangeStart + minY / HOUR_HEIGHT);
      const endHour = snapToHalf(rangeStart + maxY / HOUR_HEIGHT);
      const start = moment(currentDate).startOf('day').add(startHour, 'hours').toDate();
      const end = moment(currentDate).startOf('day').add(Math.max(endHour, startHour + 0.5), 'hours').toDate();
      handleSelectSlot({ start, end });
    } else {
      // Single click — snap to 30-min slot
      const clickedHour = snapToHalf(rangeStart + minY / HOUR_HEIGHT);
      const start = moment(currentDate).startOf('day').add(clickedHour, 'hours').toDate();
      const end = moment(start).add(30, 'minutes').toDate();
      handleSelectSlot({ start, end });
    }
  }, [dragState, rangeStart, currentDate, handleSelectSlot]);

  const handleGridMouseLeave = useCallback(() => {
    // If mouse leaves during a tiny movement, commit the drag
    if (dragState && Math.abs(dragState.currentY - dragState.startY) > 8) {
      handleGridMouseUp({ button: 0 });
    } else {
      setDragState(null);
    }
  }, [dragState, handleGridMouseUp]);

  // Selection overlay geometry
  const selectionTop = dragState ? Math.min(dragState.startY, dragState.currentY) : 0;
  const selectionHeight = dragState ? Math.abs(dragState.currentY - dragState.startY) : 0;
  const selectionStartHour = dragState ? snapToHalf(rangeStart + Math.min(dragState.startY, dragState.currentY) / HOUR_HEIGHT) : 0;
  const selectionEndHour = dragState ? snapToHalf(rangeStart + Math.max(dragState.startY, dragState.currentY) / HOUR_HEIGHT) : 0;

  const totalGridHeight = hours.length * HOUR_HEIGHT;

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f8fafc' }}>

      {/* ------------------------------------------------------------------ */}
      {/* Header                                                              */}
      {/* ------------------------------------------------------------------ */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 24px',
        borderBottom: '1px solid #e2e8f0',
        background: '#fff',
        flexShrink: 0,
      }}>
        {/* Left: navigation controls + date label */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => setCurrentDate(new Date())}
            style={{
              padding: '6px 14px',
              border: '1px solid #cbd5e1',
              borderRadius: 6,
              background: '#fff',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 500,
              color: '#374151',
              lineHeight: 1,
            }}
          >
            Today
          </button>
          <button
            onClick={() => setCurrentDate(d => moment(d).subtract(1, 'day').toDate())}
            style={{
              padding: '6px 11px',
              border: '1px solid #cbd5e1',
              borderRadius: 6,
              background: '#fff',
              cursor: 'pointer',
              fontSize: 14,
              color: '#374151',
              lineHeight: 1,
            }}
            aria-label="Previous day"
          >
            &#9664;
          </button>
          <button
            onClick={() => setCurrentDate(d => moment(d).add(1, 'day').toDate())}
            style={{
              padding: '6px 11px',
              border: '1px solid #cbd5e1',
              borderRadius: 6,
              background: '#fff',
              cursor: 'pointer',
              fontSize: 14,
              color: '#374151',
              lineHeight: 1,
            }}
            aria-label="Next day"
          >
            &#9654;
          </button>
          <span style={{ fontSize: 18, fontWeight: 600, color: '#1e293b', marginLeft: 4, userSelect: 'none' }}>
            {moment(currentDate).format('dddd, MMM D')}
          </span>
        </div>

        {/* Right: view tabs + send summary */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* View tab group */}
          <div style={{
            display: 'flex',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            overflow: 'hidden',
          }}>
            {VIEW_TABS.map((tab, idx) => (
              <button
                key={tab}
                onClick={() => { if (tab === 'Day') setCalView(tab); }}
                title={tab !== 'Day' ? 'Coming soon' : undefined}
                style={{
                  padding: '6px 15px',
                  border: 'none',
                  borderRight: idx < VIEW_TABS.length - 1 ? '1px solid #e2e8f0' : 'none',
                  background: calView === tab ? '#3b82f6' : '#fff',
                  color: calView === tab ? '#fff' : '#64748b',
                  cursor: tab === 'Day' ? 'pointer' : 'not-allowed',
                  fontSize: 13,
                  fontWeight: calView === tab ? 600 : 400,
                  opacity: tab !== 'Day' ? 0.55 : 1,
                  lineHeight: 1,
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Send summary button */}
          <button
            onClick={handleSendTimesheetEmail}
            disabled={sendingEmail}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '7px 16px',
              background: sendingEmail ? '#93c5fd' : '#3b82f6',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: sendingEmail ? 'not-allowed' : 'pointer',
              fontSize: 13,
              fontWeight: 500,
              lineHeight: 1,
            }}
          >
            <FaPaperPlane style={{ fontSize: 12 }} />
            {sendingEmail ? 'Sending...' : "Send Today's Summary"}
          </button>
        </div>
      </div>

      {/* ------------------------------------------------------------------ */}
      {/* Day load strip                                                       */}
      {/* ------------------------------------------------------------------ */}
      <div style={{
        padding: '8px 24px',
        background: '#fff',
        borderBottom: '1px solid #e2e8f0',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}>
        {/* Colored segments bar */}
        <div style={{
          flex: 1,
          height: 10,
          background: '#f1f5f9',
          borderRadius: 999,
          overflow: 'hidden',
          position: 'relative',
        }}>
          {dayEvents.map((event) => {
            const evStartH = moment(event.start).hours() + moment(event.start).minutes() / 60;
            const evEndH = moment(event.end).hours() + moment(event.end).minutes() / 60;
            const clampedStart = Math.max(evStartH, rangeStart);
            const clampedEnd = Math.min(evEndH, rangeEnd);
            if (clampedEnd <= clampedStart) return null;
            const leftPct = ((clampedStart - rangeStart) / (rangeEnd - rangeStart)) * 100;
            const widthPct = ((clampedEnd - clampedStart) / (rangeEnd - rangeStart)) * 100;
            const color = EVENT_COLORS[event.id % 4];
            return (
              <div
                key={`strip-${event.id}-${event.start}`}
                style={{
                  position: 'absolute',
                  left: `${leftPct}%`,
                  width: `${widthPct}%`,
                  height: '100%',
                  background: color.border,
                  opacity: 0.8,
                }}
              />
            );
          })}
        </div>

        <span style={{ fontSize: 12, color: '#64748b', whiteSpace: 'nowrap', fontWeight: 500 }}>
          {bookedPercent}% booked
        </span>

        <button
          onClick={() => setShowFullDay(v => !v)}
          style={{
            padding: '3px 12px',
            border: '1px solid #e2e8f0',
            borderRadius: 20,
            background: '#fff',
            cursor: 'pointer',
            fontSize: 12,
            color: '#64748b',
            whiteSpace: 'nowrap',
            lineHeight: 1.6,
          }}
        >
          {showFullDay ? 'Show business hours' : 'Show full day'}
        </button>
      </div>

      {/* ------------------------------------------------------------------ */}
      {/* Calendar grid                                                        */}
      {/* ------------------------------------------------------------------ */}
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', background: '#f8fafc' }}>

        {/* Time labels column */}
        <div style={{
          width: 64,
          flexShrink: 0,
          background: '#fff',
          borderRight: '1px solid #e2e8f0',
        }}>
          {hours.map((h) => (
            <div
              key={h}
              style={{
                height: HOUR_HEIGHT,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                paddingRight: 10,
                paddingTop: 5,
                fontSize: 11,
                color: '#94a3b8',
                fontWeight: 500,
                boxSizing: 'border-box',
                userSelect: 'none',
              }}
            >
              {formatHour(h)}
            </div>
          ))}
        </div>

        {/* Events column */}
        <div
          ref={gridRef}
          onMouseDown={handleGridMouseDown}
          onMouseMove={handleGridMouseMove}
          onMouseUp={handleGridMouseUp}
          onMouseLeave={handleGridMouseLeave}
          style={{
            flex: 1,
            position: 'relative',
            height: totalGridHeight,
            minHeight: totalGridHeight,
            cursor: dragState ? 'ns-resize' : 'cell',
            background: '#fff',
            userSelect: 'none',
          }}
        >
          {/* Hour grid lines */}
          {hours.map((h) => (
            <div
              key={`line-${h}`}
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: (h - rangeStart) * HOUR_HEIGHT,
                borderTop: '1px solid #e2e8f0',
                pointerEvents: 'none',
              }}
            />
          ))}

          {/* Half-hour dashed lines */}
          {hours.map((h) => (
            <div
              key={`halfline-${h}`}
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: (h - rangeStart) * HOUR_HEIGHT + HOUR_HEIGHT / 2,
                borderTop: '1px dashed #f1f5f9',
                pointerEvents: 'none',
              }}
            />
          ))}

          {/* "Now" line */}
          {showNowLine && (
            <div
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: nowTop,
                zIndex: 10,
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: '#ef4444',
                flexShrink: 0,
                marginLeft: -5,
              }} />
              <div style={{ flex: 1, height: 2, background: '#ef4444' }} />
            </div>
          )}

          {/* Drag selection overlay */}
          {dragState && selectionHeight > 8 && (
            <div
              style={{
                position: 'absolute',
                left: 4,
                right: 4,
                top: selectionTop,
                height: selectionHeight,
                background: 'rgba(59, 130, 246, 0.12)',
                border: '2px solid rgba(59, 130, 246, 0.5)',
                borderRadius: 6,
                pointerEvents: 'none',
                zIndex: 9,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span style={{
                fontSize: 11,
                fontWeight: 600,
                color: '#1d4ed8',
                background: 'rgba(255,255,255,0.9)',
                borderRadius: 4,
                padding: '2px 8px',
              }}>
                {moment(currentDate).startOf('day').add(selectionStartHour, 'hours').format('h:mm A')}
                {' – '}
                {moment(currentDate).startOf('day').add(Math.max(selectionEndHour, selectionStartHour + 0.5), 'hours').format('h:mm A')}
              </span>
            </div>
          )}

          {/* Event blocks */}
          {dayEvents.map((event) => {
            const startH = moment(event.start).hours() + moment(event.start).minutes() / 60;
            const endH = moment(event.end).hours() + moment(event.end).minutes() / 60;
            const top = Math.max(0, (startH - rangeStart) * HOUR_HEIGHT);
            const height = Math.max(22, (endH - startH) * HOUR_HEIGHT);
            const color = EVENT_COLORS[event.id % 4];

            return (
              <div
                key={`event-${event.id}-${event.start}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEventClick(event);
                }}
                style={{
                  position: 'absolute',
                  left: 8,
                  right: 8,
                  top,
                  height,
                  background: color.bg,
                  border: `1.5px solid ${color.border}`,
                  borderRadius: 6,
                  padding: '4px 8px',
                  cursor: 'pointer',
                  zIndex: 5,
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                }}
              >
                <div style={{
                  fontSize: 11,
                  color: color.text,
                  fontWeight: 600,
                  lineHeight: 1.3,
                  whiteSpace: 'nowrap',
                }}>
                  {moment(event.start).format('h:mm')}–{moment(event.end).format('h:mm A')}
                </div>
                <div style={{
                  fontSize: 12,
                  color: color.text,
                  fontWeight: 500,
                  lineHeight: 1.4,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                  {event.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ------------------------------------------------------------------ */}
      {/* Add Modal                                                            */}
      {/* ------------------------------------------------------------------ */}
      {showAddModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Event</h5>
                <button type="button" className="close" aria-label="Close" onClick={handleAddModalClose}>
                  <span aria-hidden="true">&#215;</span>
                </button>
              </div>
              <div className="modal-body">
                <label htmlFor="project-select">Project Name:</label>
                <Select
                  id="project-select"
                  className="mb-2"
                  value={selectedProject}
                  onChange={handleProjectChange}
                  options={getReactSelectProjectOptions(projectOptions)}
                  placeholder="Search or Select Project"
                  isSearchable
                  isClearable
                  noOptionsMessage={() =>
                    projectOptions.length === 0
                      ? "No Projects Available (except Others)"
                      : "No matching projects (except Others)"
                  }
                />
                <label htmlFor="task-select">Task Name:</label>
                <Select
                  id="task-select"
                  className="mb-2"
                  value={selectedTask}
                  onChange={handleChange}
                  options={taskOptionsStatic}
                  placeholder="Search or Select Task"
                  isSearchable
                  isClearable
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleAddModalSubmit}
                  disabled={!selectedProject || !selectedTask}
                >
                  Create Event
                </button>
                <button type="button" className="btn btn-danger" onClick={handleAddModalClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------------------------------------------------------ */}
      {/* Edit Modal                                                           */}
      {/* ------------------------------------------------------------------ */}
      {showEditModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Event</h5>
                <button type="button" className="close" aria-label="Close" onClick={handleEditModalClose}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowDeleteModal(true)}
                >
                  Delete Event
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleEditModalClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------------------------------------------------------ */}
      {/* Delete Confirmation Modal                                            */}
      {/* ------------------------------------------------------------------ */}
      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document" style={{ marginTop: '150px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={() => setShowDeleteModal(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this event? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    handleDeleteEvent();
                    setShowDeleteModal(false);
                    setShowEditModal(false);
                  }}
                >
                  Confirm Delete
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Timesheet;
